module.exports = __webpack_public_path__ + "34a15de895f3d7c211489d5a63d9c389.svg";